import React, { Component } from 'react';

export class DiagramTooltip extends Component {
  getUnit( key ) {
    const { units } = this.props;
    return units && units[key] || '';
  }

  render() {
    const { active, dataKey, payload, label } = this.props;

    const data = payload.map( item => 
      <span style={ { color: item.stroke } } key={ item.dataKey }>
        { `${item.dataKey}: ${ item.value }${this.getUnit( item.dataKey )}` }
      </span> 
    );

    if ( active ) {
      return <div className="diagram-tooltip">
        <span className="diagram-tooltip-datakey">{ `${dataKey}: ${ label }${ this.getUnit( dataKey ) }` }</span>
        { data }
      </div>;
    }

    return null;
  }
}